import { render, staticRenderFns } from "./DocumentRequestsTable.vue?vue&type=template&id=42b7540b"
import script from "./DocumentRequestsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentRequestsTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports